import type { RequestForQuotationSupplierLookup } from '../types/request-for-quotation-supplier-lookup.type';
import { EntityStatusModel } from './entity-status.model';

export class RequestForQuotationSupplierLookupModel implements RequestForQuotationSupplierLookup {
  readonly id: string;
  readonly number: string | null;
  readonly scope: string | null;
  readonly status: EntityStatusModel | null = null;
  readonly dueDate: Date;
  readonly finalDestinationCountry: string | null;
  readonly projectSCM: string | null;
  readonly canView: boolean;

  constructor(requestForQuotationLookup: RequestForQuotationSupplierLookup) {
    this.id = requestForQuotationLookup.id;
    this.number = requestForQuotationLookup.number;
    this.scope = requestForQuotationLookup.scope;

    if (requestForQuotationLookup.status) {
      this.status = new EntityStatusModel(requestForQuotationLookup.status);
    }

    this.dueDate = requestForQuotationLookup.dueDate;
    this.finalDestinationCountry =
      requestForQuotationLookup.finalDestinationCountry;
    this.projectSCM = requestForQuotationLookup.projectSCM;
    this.canView = requestForQuotationLookup.canView;
  }
}
